import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import pdf from "../../Assets/myresume.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import ReactGA from "react-ga";

function Resume() {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <Container fluid className="resume-section">
      <Particle />
          <Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="AI ML Python Developer at AeonX Digital Solutions"
              date="August 2023 - present"
              content={[
                "Learned and implemented new technologies, AWS cloud services like S3, QuickSight, Bedrock, RDS, AmazonMQ and DynamoDB etc.",
                "Developed and automated model training, production and inventory management system for Konark industries through devices such as Raspberry Pi, Machine Vision cameras.",
                "Collected real time data from multiple CNC machines for Maini industries using OPC server and an additional gateway IoT device, stored it on the cloud and displayed on dashboard using AWS Quicksight.",
                "Built a multi-tenant, full automated machine vision SaaS application for Sunder Biscuit to enable real-time inventory tracking, leveraging IoT gateways, PLCs, industrial sensors, and vision cameras, with seamless end-to-end automation and cloud integration."
              ]}
            />
            <Resumecontent
              title="Trainee AI ML Developer at Innovative Engineers"
              date="June 2023 - August 2023"
              content={[
                "Learned Machine Learning and Deep Learning concepts, algorithms and frameworks.",
                "Handled and developed AI ML model for audio and spectrum analysis.",
              ]}
            />
            <Resumecontent
              title="Intern Software and Web Developer at Digital Sky 360"
              date="Feb 2022 - March 2022"
              content={[
                "Learned Python frameworks and Core Javascript with HTML5 and CSS.",
                "Designed and Developed various client websites.",
              ]}
            />
            {/* <h3 className="resume-title">Extracurricular Activities</h3>
            <Resumecontent
              title="Technical Lead [Girlscript Surat]"
              date="March 2020 - present"
              content={[
                "As a Part of Community, we arrange lots of event,Like HackerRank contest,ReactJS Live session and lots of other stuff.",
              ]}
            />
            <Resumecontent
              title="Microsoft Learn Student Ambassador"
              date="Sep 2019 - March 2021"
              content={[
                "Under the Microsoft Learn Student Ambassadors programme, I started my cloud journey and learn basics of azure and i hosted several events Like hosting github session, Benifits of open source programme and and its community and much more.",
              ]}
            /> */}
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="MSc Bioinformatics "
              date="2021 - 2023"
              content={[
                "I persued my masters degree from Gujarat University, Ahmedabad.",
              ]}
            />
            <Resumecontent
              title="BSc Biotechnology "
              date="2018 - 2021"
              content={[
                "I persued my bachelors degree from President Science College, Ahmedabad affiliated to Gujarat University.",
              ]}
            />

            <h3 className="resume-title">Certifications</h3>
            <Resumecontent
              title=""
              content={[
                'Claude Certified Architect - Foundation',
                'Associate Google Cloud Engineer',
                `Github Foundations`,
                `Python Programming and Web developing from TCS Ion.`,
                `Data Science and Machine Learning from Acmegrade.`,
              ]}
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
        </Row>
      </Container>
          <Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
    </Container>
  );
}

export default Resume;
